import { createContext } from "react";

export const DescuentosContext = createContext()
export const DescuentosFormContext = createContext()
export const DescuentosReportContext = createContext()